import { styled } from "@pigment-css/react";
import { Flex } from "@acto/taskpane/core/components/flex/Flex";

export const PaddingWrapper = styled(Flex)(({ theme }) => ({
  padding: `${theme.managementView.spacing[24]} ${theme.managementView.spacing[32]}`,
}));

export const Divider = styled("div")(({ theme }) => ({
  width: `calc(100% + 2 * ${theme.managementView.spacing[32]})`,
  marginLeft: `-${theme.managementView.spacing[32]}`,
  marginRight: `-${theme.managementView.spacing[32]}`,
  height: "1px",
  backgroundColor: theme.managementView.colors.neutral[8],
}));
